// extracted by mini-css-extract-plugin
export default {"linkStyle":"groupNameAndNumberRenderer_linkStyle__0Ir9n"};